import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import React, { useCallback, useContext } from 'react';
import { useModalActions } from '../../../../main/src/components/app/layout/Modals/modalActions';

import { ReviewViewContext } from '../../../../main/src/components/app/layout/ReviewTool/Context/reviewViewContext';
import {
    ReviewAssetViewerContext,
    ReviewToolContext
} from '../../../../main/src/components/app/layout/ReviewTool/Context/reviewToolContext';

/**Add comment from the video controls view mobile view */

interface Props {
    onAddComment?: () => void;
    playing?: boolean;
    drawingBarToggled?: boolean;
    toggleDrawingBar?: (toggle?: boolean) => void;
}

export const AddCommentButton: React.ComponentType<Props> = React.memo(
    (props) => {
        const {
            onAddComment,
            playing,
            drawingBarToggled
        } = props;

        const modalActions = useModalActions();
        const { activeAsset, reviewLink, email, userImage } =
            useContext(ReviewViewContext) || {};
        const {
            drawnSvg,
            player,
            activeTemplate,
            setDrawnSvg,
            setActiveComment,
            toggleDrawingBar
        } = useContext(ReviewToolContext) || {};
        const { timestamp } = useContext(ReviewAssetViewerContext) || {};


        const handleAddComment = useCallback(() => {
            onAddComment?.();
            modalActions.openModal('reviewlink_addComment', {
                activeAsset, reviewLink, email, userImage,
                drawnSvg,
                drawingBarToggled,
                player,
                playing,
                activeTemplate,
                setDrawnSvg,
                setActiveComment,
                toggleDrawingBar,
                timestamp
            });

        }, [activeAsset, reviewLink, email, userImage,
            drawnSvg,
            drawingBarToggled,
            player,
            playing,
            activeTemplate,
            setDrawnSvg,
            setActiveComment,
            toggleDrawingBar
        ]);


        return (<>
            <Button
                aria-label="add commend"
                iconLeft={'chat_bubble_add'}
                background="secondary"
                buttonStyle="ghost"
                onClick={handleAddComment}
                size={SizeVariants.lg}
            />
        </>);
    }
);
